import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchGetAgendaWithAssignment = async (agendaId) => {
  // 쿼리 파라미터가 추가된 URL로 API를 호출합니다.

  return await api.get(`/admin/assignment/${agendaId}`);
};

export const useGetAgendaWithAssignmentQuery = ({ agendaId }) => {
  return useQuery({
    queryKey: ["admin-assignments", agendaId],
    enabled: !!agendaId,
    queryFn: () => fetchGetAgendaWithAssignment(agendaId),
    select: (data) => {
      return data.data.data;
    },
  });
};
